module.exports = __webpack_public_path__ + "static/Chicory1-e1d9811b65e41b474285b0eb70a466c1.png";